var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.showResult
    ? _c(
        "button",
        {
          staticClass: "btn --primary mt-auto",
          attrs: { disabled: !_vm.odpoved.input },
          on: { click: _vm.checkResponse }
        },
        [
          _vm._v("\n    skontrolovať"),
          _c("span", { staticClass: "icon icon--check ml-10" })
        ]
      )
    : _c(
        "button",
        { staticClass: "btn --primary mt-auto", on: { click: _vm.next } },
        [
          _vm._v("\n    pokračovať"),
          _c("span", { staticClass: "icon icon--arrow-right ml-10" })
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }